import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Card,
  Row,
  Col,
  Button,
  Badge,
  Table,
  Alert,
  Form,
  InputGroup,
  Tab,
  Tabs,
  Spinner
} from 'react-bootstrap';
import {
  FileText,
  Heart,
  Activity,
  Calendar,
  Clock,
  CheckCircle,
  FileMedical,
  Syringe,
  Pill,
  Hospital,
  Microscope,
  Search,
  Download,
  Printer,
  InfoCircle,
  PersonCircle,
  Droplet,
  Phone,
  People,
  Prescription,
  GraphUp,
  Shield,
  CalendarEvent,
  ChevronRight,
  Award,
  Camera,
  ArrowLeft,
  ChevronDown,
  ChevronUp
} from 'react-bootstrap-icons';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import cnamgsLogo from '../../assets/img/cnamgs_cover.jpeg';

// === Données des patients (identique à MyPatients) ===
const allPatients = [
  { id: 'CNAMGS-123456', name: 'Jean Dupont', birthDate: '15/05/1985', lastVisit: '2025-03-12', phone: '+241 01 23 45 67', email: 'jean.dupont@email.ga', bloodType: 'A+', photo: 'https://randomuser.me/api/portraits/men/1.jpg', history: 'Hypertension, allergie aux pénicillines' },
  { id: 'CNAMGS-789012', name: 'Marie Nzogho', birthDate: '23/09/1990', lastVisit: '2025-03-10', phone: '+241 01 23 45 68', email: 'marie.nzogho@email.ga', bloodType: 'O+', photo: 'https://randomuser.me/api/portraits/women/2.jpg', history: 'Asthme, diabète type 2' },
  { id: 'CNAMGS-345678', name: 'Pierre Mba', birthDate: '10/12/1978', lastVisit: '2025-03-05', phone: '+241 01 23 45 69', email: 'pierre.mba@email.ga', bloodType: 'B+', photo: 'https://randomuser.me/api/portraits/men/3.jpg', history: 'Aucun antécédent notable' },
  { id: 'CNAMGS-111222', name: 'Sophie Nguema', birthDate: '02/07/1995', lastVisit: '2025-03-15', phone: '+241 01 23 45 70', email: 'sophie.nguema@email.ga', bloodType: 'A-', photo: 'https://randomuser.me/api/portraits/women/4.jpg', history: 'Allergie aux pollens' },
  { id: 'CNAMGS-333444', name: 'Paul Obiang', birthDate: '18/11/1982', lastVisit: '2025-03-08', phone: '+241 01 23 45 71', email: 'paul.obiang@email.ga', bloodType: 'AB+', photo: 'https://randomuser.me/api/portraits/men/5.jpg', history: 'Diabète de type 2' },
  { id: 'CNAMGS-555666', name: 'Claire Moussavou', birthDate: '30/01/1989', lastVisit: '2025-03-14', phone: '+241 01 23 45 72', email: 'claire.moussavou@email.ga', bloodType: 'O-', photo: 'https://randomuser.me/api/portraits/women/6.jpg', history: 'Aucun antécédent' },
  { id: 'CNAMGS-777888', name: 'David Ngoma', birthDate: '05/04/1975', lastVisit: '2025-03-02', phone: '+241 01 23 45 73', email: 'david.ngoma@email.ga', bloodType: 'B-', photo: 'https://randomuser.me/api/portraits/men/7.jpg', history: 'Hypertension' },
  { id: 'CNAMGS-999000', name: 'Anne Mintogo', birthDate: '22/12/1992', lastVisit: '2025-03-09', phone: '+241 01 23 45 74', email: 'anne.mintogo@email.ga', bloodType: 'A+', photo: 'https://randomuser.me/api/portraits/women/8.jpg', history: 'Aucun antécédent' },
];

// === Données détaillées pour chaque patient ===
const consultationsData = {
  'CNAMGS-123456': [
    { id: 'C001', date: '2025-03-12', doctor: 'Dr. Nzogho', specialty: 'Médecine générale', reason: 'Fièvre et maux de tête', diagnosis: 'Grippe saisonnière', status: 'Terminé' },
    { id: 'C002', date: '2025-03-01', doctor: 'Dr. Mba', specialty: 'Cardiologie', reason: 'Contrôle annuel', diagnosis: 'Normal', status: 'Terminé' },
  ],
  'CNAMGS-789012': [
    { id: 'C003', date: '2025-03-10', doctor: 'Dr. Ondo', specialty: 'Dermatologie', reason: 'Éruption cutanée', diagnosis: 'Allergie légère', status: 'Terminé' },
  ],
  'CNAMGS-345678': [
    { id: 'C004', date: '2025-03-05', doctor: 'Dr. Nzogho', specialty: 'Médecine générale', reason: 'Toux persistante', diagnosis: 'Bronchite', status: 'Terminé' },
  ],
  'CNAMGS-111222': [
    { id: 'C005', date: '2025-03-15', doctor: 'Dr. Ondo', specialty: 'Allergologie', reason: 'Rhinite allergique', diagnosis: 'Allergie aux pollens', status: 'Terminé' },
  ],
  'CNAMGS-333444': [
    { id: 'C006', date: '2025-03-08', doctor: 'Dr. Mba', specialty: 'Endocrinologie', reason: 'Contrôle diabète', diagnosis: 'Stable', status: 'Terminé' },
  ],
  'CNAMGS-555666': [
    { id: 'C007', date: '2025-03-14', doctor: 'Dr. Nzogho', specialty: 'Médecine générale', reason: 'Fatigue', diagnosis: 'Carence en fer', status: 'Terminé' },
  ],
  'CNAMGS-777888': [
    { id: 'C008', date: '2025-03-02', doctor: 'Dr. Mba', specialty: 'Cardiologie', reason: 'Suivi tension', diagnosis: 'Normale', status: 'Terminé' },
  ],
  'CNAMGS-999000': [
    { id: 'C009', date: '2025-03-09', doctor: 'Dr. Ondo', specialty: 'Gynécologie', reason: 'Contrôle annuel', diagnosis: 'Normal', status: 'Terminé' },
  ],
};

const prescriptionsData = {
  'CNAMGS-123456': [
    { id: 'P001', date: '2025-03-12', doctor: 'Dr. Nzogho', medicines: ['Paracétamol 500mg', 'Vitamine C'], dosage: '2x/jour', duration: '5 jours', status: 'En cours' },
    { id: 'P002', date: '2025-03-01', doctor: 'Dr. Mba', medicines: ['Aucun'], dosage: '-', duration: '-', status: 'Terminé' },
  ],
  'CNAMGS-789012': [
    { id: 'P003', date: '2025-03-10', doctor: 'Dr. Ondo', medicines: ['Cetirizine 10mg'], dosage: '1x/jour', duration: '7 jours', status: 'Terminé' },
  ],
  'CNAMGS-345678': [
    { id: 'P004', date: '2025-03-05', doctor: 'Dr. Nzogho', medicines: ['Amoxicilline 500mg'], dosage: '2x/jour', duration: '7 jours', status: 'Terminé' },
  ],
  'CNAMGS-111222': [
    { id: 'P005', date: '2025-03-15', doctor: 'Dr. Ondo', medicines: ['Loratadine 10mg'], dosage: '1x/jour', duration: '10 jours', status: 'Terminé' },
  ],
  'CNAMGS-333444': [
    { id: 'P006', date: '2025-03-08', doctor: 'Dr. Mba', medicines: ['Metformine 500mg'], dosage: '2x/jour', duration: 'En continu', status: 'En cours' },
  ],
  'CNAMGS-555666': [
    { id: 'P007', date: '2025-03-14', doctor: 'Dr. Nzogho', medicines: ['Fer 80mg'], dosage: '1x/jour', duration: '30 jours', status: 'En cours' },
  ],
  'CNAMGS-777888': [
    { id: 'P008', date: '2025-03-02', doctor: 'Dr. Mba', medicines: ['Aucun'], dosage: '-', duration: '-', status: 'Terminé' },
  ],
  'CNAMGS-999000': [
    { id: 'P009', date: '2025-03-09', doctor: 'Dr. Ondo', medicines: ['Aucun'], dosage: '-', duration: '-', status: 'Terminé' },
  ],
};

const labResultsData = {
  'CNAMGS-123456': [{ id: 'L001', date: '2025-03-01', type: 'Analyse sanguine', lab: 'Laboratoire Central', results: 'Normaux', status: 'Disponible' }],
  'CNAMGS-789012': [{ id: 'L002', date: '2025-02-15', type: 'Glycémie', lab: 'Laboratoire Central', results: '5.2 mmol/L (Normal)', status: 'Disponible' }],
  'CNAMGS-345678': [{ id: 'L003', date: '2025-01-20', type: 'Cholestérol', lab: 'Laboratoire Moderne', results: '1.8 g/L (Normal)', status: 'Disponible' }],
  'CNAMGS-111222': [{ id: 'L004', date: '2025-03-10', type: 'Allergènes', lab: 'Laboratoire Central', results: 'Positif aux pollens', status: 'Disponible' }],
  'CNAMGS-333444': [{ id: 'L005', date: '2025-03-05', type: 'HbA1c', lab: 'Laboratoire Central', results: '6.2% (Contrôlé)', status: 'Disponible' }],
  'CNAMGS-555666': [{ id: 'L006', date: '2025-03-12', type: 'Ferritine', lab: 'Laboratoire Moderne', results: '12 µg/L (Carence)', status: 'Disponible' }],
  'CNAMGS-777888': [{ id: 'L007', date: '2025-02-28', type: 'Tension artérielle', lab: 'Cabinet médical', results: '12/8', status: 'Disponible' }],
  'CNAMGS-999000': [{ id: 'L008', date: '2025-03-07', type: 'Frottis', lab: 'Laboratoire Central', results: 'Normal', status: 'Disponible' }],
};

const vaccinationsData = {
  'CNAMGS-123456': [{ id: 'V001', date: '2025-02-15', vaccine: 'Grippe saisonnière', doctor: 'Dr. Nzogho', nextDose: '2026-02-15', status: 'À jour' }],
  'CNAMGS-789012': [{ id: 'V002', date: '2024-10-10', vaccine: 'Tétanos', doctor: 'Dr. Mba', nextDose: '2029-10-10', status: 'À jour' }],
  'CNAMGS-345678': [{ id: 'V003', date: '2024-05-20', vaccine: 'Hépatite B', doctor: 'Dr. Ondo', nextDose: '2025-05-20', status: 'À renouveler' }],
  'CNAMGS-111222': [{ id: 'V004', date: '2025-01-10', vaccine: 'Grippe', doctor: 'Dr. Nzogho', nextDose: '2026-01-10', status: 'À jour' }],
  'CNAMGS-333444': [],
  'CNAMGS-555666': [],
  'CNAMGS-777888': [{ id: 'V005', date: '2024-11-01', vaccine: 'Pneumocoque', doctor: 'Dr. Mba', nextDose: '2029-11-01', status: 'À jour' }],
  'CNAMGS-999000': [],
};

const upcomingAppointmentsData = {
  'CNAMGS-123456': [{ id: 'A001', date: '2025-04-05', time: '10:30', doctor: 'Dr. Nzogho', specialty: 'Médecine générale', reason: 'Consultation de suivi', status: 'Confirmé' }],
  'CNAMGS-789012': [{ id: 'A002', date: '2025-04-15', time: '14:00', doctor: 'Dr. Mba', specialty: 'Cardiologie', reason: 'Contrôle annuel', status: 'Confirmé' }],
  'CNAMGS-345678': [],
  'CNAMGS-111222': [{ id: 'A003', date: '2025-04-10', time: '09:00', doctor: 'Dr. Ondo', specialty: 'Allergologie', reason: 'Suivi allergie', status: 'Confirmé' }],
  'CNAMGS-333444': [{ id: 'A004', date: '2025-04-20', time: '11:00', doctor: 'Dr. Mba', specialty: 'Endocrinologie', reason: 'Contrôle diabète', status: 'Confirmé' }],
  'CNAMGS-555666': [],
  'CNAMGS-777888': [],
  'CNAMGS-999000': [],
};

const PatientMedicalRecord = () => {
  const { patientId } = useParams();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [activeTab, setActiveTab] = useState('consultations');
  const [exporting, setExporting] = useState(false);
  const [printing, setPrinting] = useState(false);
  const [expandedRows, setExpandedRows] = useState(new Set());

  const toggleRow = (id) => {
    const newSet = new Set(expandedRows);
    if (newSet.has(id)) newSet.delete(id);
    else newSet.add(id);
    setExpandedRows(newSet);
  };

  const patient = allPatients.find(p => p.id === patientId);
  if (!patient) {
    return (
      <div className="container mt-5 text-center">
        <h3>Patient introuvable</h3>
        <Button variant="primary" onClick={() => navigate('/doctor/search')}>
          Retour à la recherche
        </Button>
      </div>
    );
  }

  const consultations = consultationsData[patientId] || [];
  const prescriptions = prescriptionsData[patientId] || [];
  const labResults = labResultsData[patientId] || [];
  const vaccinations = vaccinationsData[patientId] || [];
  const upcomingAppointments = upcomingAppointmentsData[patientId] || [];

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  const getStatusBadge = (status) => {
    const badges = {
      Terminé: <Badge bg="success" className="rounded-pill px-3 py-2"><CheckCircle size={12} className="me-1" /> Terminé</Badge>,
      'En cours': <Badge bg="warning" className="rounded-pill px-3 py-2"><Clock size={12} className="me-1" /> En cours</Badge>,
      Disponible: <Badge bg="success" className="rounded-pill px-3 py-2"><CheckCircle size={12} className="me-1" /> Disponible</Badge>,
      'À jour': <Badge bg="success" className="rounded-pill px-3 py-2"><CheckCircle size={12} className="me-1" /> À jour</Badge>,
      'À renouveler': <Badge bg="danger" className="rounded-pill px-3 py-2"><Clock size={12} className="me-1" /> À renouveler</Badge>,
      Confirmé: <Badge bg="info" className="rounded-pill px-3 py-2"><CheckCircle size={12} className="me-1" /> Confirmé</Badge>,
    };
    return badges[status] || <Badge bg="secondary">{status}</Badge>;
  };

  const filteredConsultations = consultations.filter(c =>
    c.doctor.toLowerCase().includes(searchTerm.toLowerCase()) ||
    c.reason.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredPrescriptions = prescriptions.filter(p =>
    p.doctor.toLowerCase().includes(searchTerm.toLowerCase()) ||
    p.medicines.join().toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredLabResults = labResults.filter(l =>
    l.type.toLowerCase().includes(searchTerm.toLowerCase()) ||
    l.lab.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const statsCards = [
    { title: 'Consultations', value: consultations.length, icon: People, color: '#4361ee', gradient: 'linear-gradient(135deg, #4361ee 0%, #3b2a9f 100%)', bg: 'white', trend: `${consultations.length > 0 ? '+' : ''}${consultations.length}` },
    { title: 'Ordonnances', value: prescriptions.length, icon: Prescription, color: '#10b981', gradient: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', bg: 'white', trend: `${prescriptions.length > 0 ? '+' : ''}${prescriptions.length}` },
    { title: 'Analyses', value: labResults.length, icon: GraphUp, color: '#06b6d4', gradient: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)', bg: 'white', trend: `${labResults.length > 0 ? '+' : ''}${labResults.length}` },
    { title: 'Vaccinations', value: vaccinations.length, icon: Shield, color: '#f59e0b', gradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', bg: 'white', trend: `${vaccinations.length > 0 ? '+' : ''}${vaccinations.length}` },
  ];

  const handleExport = () => {
    setExporting(true);
    setTimeout(() => {
      alert('Export PDF (simulation)');
      setExporting(false);
    }, 800);
  };
  const handlePrint = () => {
    setPrinting(true);
    setTimeout(() => {
      window.print();
      setPrinting(false);
    }, 500);
  };

  return (
    <div className="" style={{ fontFamily: "'Inter', sans-serif" }}>
      <div className="container-fluid">
        {/* En-tête */}
        <div className="mb-4">
          <Button
            variant="link"
            className="p-0 mb-2 d-flex align-items-center text-decoration-none"
            onClick={() => navigate('/doctor/search')}
          >
            <ArrowLeft size={18} className="me-1" /> Retour à la recherche
          </Button>
          <h4 className="main-title mb-0 d-flex align-items-center gap-2">
            <div className="bg-primary bg-opacity-10 rounded-circle p-2">
              <FileMedical size={24} className="text-primary" />
            </div>
            Dossier médical de {patient.name}
          </h4>
          <p className="text-muted mb-0 mt-1">
            Consultez l'ensemble des informations médicales du patient
          </p>
        </div>

        {/* Informations personnelles */}
        <Row className="g-4 mb-4">
          <Col md={12}>
            <Card className="border-0 shadow-sm bg-white" style={{ borderRadius: '20px', overflow: 'hidden' }}>
              <div className="p-4" style={{ background: 'linear-gradient(135deg, #667eea 0%, #122c9f 100%)' }}>
                <h5 className="mb-0 fw-semibold d-flex align-items-center gap-2 text-white">
                  <PersonCircle size={20} />
                  Informations personnelles
                </h5>
              </div>
              <Card.Body className="p-4">
                <Row className="g-4">
                  <Col md={3} className="text-center">
                    <div className="position-relative d-inline-block">
                      <div
                        style={{
                          width: '140px',
                          height: '140px',
                          borderRadius: '50%',
                          overflow: 'hidden',
                          border: `4px solid #fff`,
                          boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
                          margin: '0 auto',
                          background: '#f0f0f0',
                        }}
                      >
                        <img
                          src={patient.photo}
                          alt="Photo de profil"
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                      </div>
                      <div
                        className="position-absolute bottom-0 end-0 bg-primary rounded-circle p-2"
                        style={{ transform: 'translate(10%, 10%)' }}
                      >
                        <Camera size={16} className="text-white" />
                      </div>
                    </div>
                    <div className="mt-3">
                      <Badge bg="success" className="rounded-pill px-3 py-2">
                        <CheckCircle size={12} className="me-1" /> Vérifié
                      </Badge>
                    </div>
                    <div className="mt-3">
                      <div
                        className="p-3 rounded-3"
                        style={{
                          background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                          borderLeft: '4px solid #f59e0b',
                        }}
                      >
                        <small className="text-muted d-block mb-1">Groupe sanguin</small>
                        <strong className="fs-6">
                          <Droplet size={14} className="text-danger me-1" /> {patient.bloodType}
                        </strong>
                      </div>
                    </div>
                  </Col>
                  <Col md={9}>
                    <Row className="g-3">
                      <Col md={4} xs={6}>
                        <div
                          className="p-3 rounded-3"
                          style={{
                            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                            borderLeft: '4px solid #4361ee',
                          }}
                        >
                          <small className="text-muted d-block mb-1">Nom complet</small>
                          <strong style={{ fontSize: '12px' }}>{patient.name}</strong>
                        </div>
                      </Col>
                      <Col md={4} xs={6}>
                        <div
                          className="p-3 rounded-3"
                          style={{
                            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                            borderLeft: '4px solid #10b981',
                          }}
                        >
                          <small className="text-muted d-block mb-1">Numéro d'assuré</small>
                          <strong className="fs-6">{patient.id}</strong>
                        </div>
                      </Col>
                      <Col md={4} xs={6}>
                        <div
                          className="p-3 rounded-3"
                          style={{
                            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                            borderLeft: '4px solid #06b6d4',
                          }}
                        >
                          <small className="text-muted d-block mb-1">Date de naissance</small>
                          <strong className="fs-6">{patient.birthDate}</strong>
                        </div>
                      </Col>
                      <Col md={4} xs={6}>
                        <div
                          className="p-3 rounded-3"
                          style={{
                            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                            borderLeft: '4px solid #ef4444',
                          }}
                        >
                          <small className="text-muted d-block mb-1">Taille / Poids</small>
                          <strong className="fs-6">170 cm / 70 kg</strong>
                        </div>
                      </Col>
                      <Col md={8}>
                        <div
                          className="p-3 rounded-3"
                          style={{ background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)' }}
                        >
                          <small className="text-muted d-block mb-1">Allergies</small>
                          <Badge bg="warning" className="rounded-pill px-3 py-2">
                            {patient.history.includes('allergie') ? 'Pénicillines' : 'Aucune'}
                          </Badge>
                        </div>
                      </Col>
                    </Row>
                    <hr className="my-3" />
                    <div
                      className="d-flex align-items-center gap-4 flex-wrap p-3 rounded-3"
                      style={{ background: '#f8f9fa' }}
                    >
                      <div>
                        <small className="text-muted d-block mb-1">Contact d'urgence</small>
                        <strong>Jean Moukita</strong>
                      </div>
                      <div>
                        <Phone size={14} className="text-muted me-1" />
                        <span>+241 01 23 45 67</span>
                      </div>
                      <div>
                        <span className="text-muted">Conjoint</span>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Cartes de statistiques */}
        <Row className="g-3 mb-4">
          {statsCards.map((card, idx) => (
            <Col md={3} xs={6} key={idx}>
              <Card
                className="border-0 shadow-sm overflow-hidden stats-card"
                style={{ borderRadius: '16px', background: card.bg }}
              >
                <div className="stats-card-gradient" style={{ background: card.gradient }}></div>
                <Card.Body className="p-3">
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <h6 className="text-muted mb-1 small">{card.title}</h6>
                      <h2 className="mb-0 fw-bold display-6">{card.value}</h2>
                      <div className="mt-2">
                        <Badge
                          className="rounded-pill px-2 py-1"
                          style={{ background: card.color, color: 'white', fontSize: '10px' }}
                        >
                          <GraphUp size={10} className="me-1" />
                          {card.trend}
                        </Badge>
                      </div>
                    </div>
                    <div className="stats-icon" style={{ background: card.gradient }}>
                      <card.icon size={28} className="text-white" />
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Barre de recherche */}
        <Row className="mb-4">
          <Col md={12}>
            <Card className="border-0 shadow-sm bg-white" style={{ borderRadius: '16px' }}>
              <Card.Body>
                <InputGroup>
                  <InputGroup.Text className="bg-light border-0">
                    <Search size={16} className="text-muted" />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Rechercher dans le dossier médical..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="border-0 bg-light"
                  />
                </InputGroup>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Onglets */}
        <Row>
          <Col md={12}>
            <Card className="border-0 shadow-sm bg-white" style={{ borderRadius: '16px', overflow: 'hidden' }}>
              <Tabs
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
                className="border-bottom px-3 pt-2"
                fill
              >
                <Tab
                  eventKey="consultations"
                  title={<span><People className="me-2" /> Consultations</span>}
                >
                  <div className="p-3">
                    <div className="table-responsive">
                      <Table hover className="mb-0">
                        <thead className="bg-light">
                          <tr>
                            <th>Date</th>
                            <th>Médecin</th>
                            <th className="d-none d-sm-table-cell">Spécialité</th>
                            <th className="d-none d-sm-table-cell">Motif</th>
                            <th className="d-none d-sm-table-cell">Diagnostic</th>
                            <th>Statut</th>
                            <th className="d-sm-none text-center">Détails</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredConsultations.map((c) => {
                            const isExpanded = expandedRows.has(c.id);
                            return (
                              <React.Fragment key={c.id}>
                                <tr>
                                  <td data-label="Date" className="small">{formatDate(c.date)}</td>
                                  <td data-label="Médecin" className="fw-medium">{c.doctor}</td>
                                  <td data-label="Spécialité" className="d-none d-sm-table-cell">{c.specialty}</td>
                                  <td data-label="Motif" className="d-none d-sm-table-cell">{c.reason}</td>
                                  <td data-label="Diagnostic" className="d-none d-sm-table-cell">{c.diagnosis}</td>
                                  <td data-label="Statut">{getStatusBadge(c.status)}</td>
                                  <td className="d-sm-none text-center" style={{ verticalAlign: 'middle' }}>
                                    <Button
                                      variant="link"
                                      onClick={() => toggleRow(c.id)}
                                      className="p-0 text-secondary"
                                      style={{ textDecoration: 'none' }}
                                    >
                                      {isExpanded ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                                    </Button>
                                  </td>
                                </tr>
                                {isExpanded && (
                                  <tr className="d-sm-none detail-row">
                                    <td colSpan="7" className="p-3 bg-light">
                                      <div className="row g-2">
                                        <div className="col-12"><strong>Spécialité :</strong> {c.specialty}</div>
                                        <div className="col-12"><strong>Motif :</strong> {c.reason}</div>
                                        <div className="col-12"><strong>Diagnostic :</strong> {c.diagnosis}</div>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </Tab>

                <Tab
                  eventKey="prescriptions"
                  title={<span><Prescription className="me-2" /> Ordonnances</span>}
                >
                  <div className="p-3">
                    <div className="table-responsive">
                      <Table hover className="mb-0">
                        <thead className="bg-light">
                          <tr>
                            <th>Date</th>
                            <th>Médecin</th>
                            <th className="d-none d-sm-table-cell">Médicaments</th>
                            <th className="d-none d-sm-table-cell">Posologie</th>
                            <th className="d-none d-sm-table-cell">Durée</th>
                            <th>Statut</th>
                            <th className="d-sm-none text-center">Détails</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredPrescriptions.map((p) => {
                            const isExpanded = expandedRows.has(p.id);
                            return (
                              <React.Fragment key={p.id}>
                                <tr>
                                  <td data-label="Date" className="small">{formatDate(p.date)}</td>
                                  <td data-label="Médecin" className="fw-medium">{p.doctor}</td>
                                  <td data-label="Médicaments" className="d-none d-sm-table-cell">{p.medicines.join(', ')}</td>
                                  <td data-label="Posologie" className="d-none d-sm-table-cell">{p.dosage}</td>
                                  <td data-label="Durée" className="d-none d-sm-table-cell">{p.duration}</td>
                                  <td data-label="Statut">{getStatusBadge(p.status)}</td>
                                  <td className="d-sm-none text-center">
                                    <Button variant="link" onClick={() => toggleRow(p.id)} className="p-0 text-secondary" style={{ textDecoration: 'none' }}>
                                      {isExpanded ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                                    </Button>
                                  </td>
                                </tr>
                                {isExpanded && (
                                  <tr className="d-sm-none detail-row">
                                    <td colSpan="7" className="p-3 bg-light">
                                      <div className="row g-2">
                                        <div className="col-12"><strong>Médicaments :</strong> {p.medicines.join(', ')}</div>
                                        <div className="col-12"><strong>Posologie :</strong> {p.dosage}</div>
                                        <div className="col-12"><strong>Durée :</strong> {p.duration}</div>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </Tab>

                <Tab
                  eventKey="lab-results"
                  title={<span><GraphUp className="me-2" /> Analyses</span>}
                >
                  <div className="p-3">
                    <div className="table-responsive">
                      <Table hover className="mb-0">
                        <thead className="bg-light">
                          <tr>
                            <th>Date</th>
                            <th>Type</th>
                            <th className="d-none d-sm-table-cell">Laboratoire</th>
                            <th className="d-none d-sm-table-cell">Résultats</th>
                            <th>Statut</th>
                            <th>Action</th>
                            <th className="d-sm-none text-center">Détails</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredLabResults.map((l) => {
                            const isExpanded = expandedRows.has(l.id);
                            return (
                              <React.Fragment key={l.id}>
                                <tr>
                                  <td data-label="Date" className="small">{formatDate(l.date)}</td>
                                  <td data-label="Type" className="fw-medium">{l.type}</td>
                                  <td data-label="Laboratoire" className="d-none d-sm-table-cell">{l.lab}</td>
                                  <td data-label="Résultats" className="d-none d-sm-table-cell">{l.results}</td>
                                  <td data-label="Statut">{getStatusBadge(l.status)}</td>
                                  <td data-label="Action"><Button variant="link" size="sm" className="p-0 text-decoration-none"><FileText size={16} className="text-primary me-1" /> Voir</Button></td>
                                  <td className="d-sm-none text-center">
                                    <Button variant="link" onClick={() => toggleRow(l.id)} className="p-0 text-secondary" style={{ textDecoration: 'none' }}>
                                      {isExpanded ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                                    </Button>
                                  </td>
                                </tr>
                                {isExpanded && (
                                  <tr className="d-sm-none detail-row">
                                    <td colSpan="7" className="p-3 bg-light">
                                      <div className="row g-2">
                                        <div className="col-12"><strong>Laboratoire :</strong> {l.lab}</div>
                                        <div className="col-12"><strong>Résultats :</strong> {l.results}</div>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </Tab>

                <Tab
                  eventKey="vaccinations"
                  title={<span><Shield className="me-2" /> Vaccinations</span>}
                >
                  <div className="p-3">
                    <div className="table-responsive">
                      <Table hover className="mb-0">
                        <thead className="bg-light">
                          <tr>
                            <th>Date</th>
                            <th>Vaccin</th>
                            <th className="d-none d-sm-table-cell">Médecin</th>
                            <th className="d-none d-sm-table-cell">Prochain rappel</th>
                            <th>Statut</th>
                            <th className="d-sm-none text-center">Détails</th>
                          </tr>
                        </thead>
                        <tbody>
                          {vaccinations.map((v) => {
                            const isExpanded = expandedRows.has(v.id);
                            return (
                              <React.Fragment key={v.id}>
                                <tr>
                                  <td data-label="Date" className="small">{formatDate(v.date)}</td>
                                  <td data-label="Vaccin" className="fw-medium">{v.vaccine}</td>
                                  <td data-label="Médecin" className="d-none d-sm-table-cell">{v.doctor}</td>
                                  <td data-label="Prochain rappel" className="d-none d-sm-table-cell">{formatDate(v.nextDose)}</td>
                                  <td data-label="Statut">{getStatusBadge(v.status)}</td>
                                  <td className="d-sm-none text-center">
                                    <Button variant="link" onClick={() => toggleRow(v.id)} className="p-0 text-secondary" style={{ textDecoration: 'none' }}>
                                      {isExpanded ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                                    </Button>
                                  </td>
                                </tr>
                                {isExpanded && (
                                  <tr className="d-sm-none detail-row">
                                    <td colSpan="6" className="p-3 bg-light">
                                      <div className="row g-2">
                                        <div className="col-12"><strong>Médecin :</strong> {v.doctor}</div>
                                        <div className="col-12"><strong>Prochain rappel :</strong> {formatDate(v.nextDose)}</div>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </Tab>

                <Tab
                  eventKey="appointments"
                  title={<span><CalendarEvent className="me-2" /> Rendez-vous</span>}
                >
                  <div className="p-3">
                    <Row className="g-3">
                      {upcomingAppointments.map((a) => (
                        <Col md={6} key={a.id}>
                          <Card className="border-0 shadow-sm h-100" style={{ borderRadius: '16px' }}>
                            <Card.Body>
                              <div className="d-flex justify-content-between align-items-start mb-2">
                                <h6 className="fw-bold mb-0">{a.doctor}</h6>
                                {getStatusBadge(a.status)}
                              </div>
                              <p className="small text-muted mb-2">{a.specialty}</p>
                              <div className="d-flex gap-3 small mb-2">
                                <span><Calendar size={12} className="me-1" /> {formatDate(a.date)}</span>
                                <span><Clock size={12} className="me-1" /> {a.time}</span>
                              </div>
                              <p className="small mb-3">{a.reason}</p>
                              <Button variant="outline-primary" size="sm" className="rounded-pill w-100">Modifier</Button>
                            </Card.Body>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </Tab>
              </Tabs>
            </Card>
          </Col>
        </Row>

        {/* Information */}
        <Row className="mt-4">
          <Col md={12}>
            <Alert variant="info" className="border-0 rounded-3 shadow-sm" style={{ background: 'linear-gradient(135deg, #e8f4fd 0%, #d9eaff 100%)' }}>
              <div className="d-flex align-items-center gap-3">
                <InfoCircle size={24} className="text-info" />
                <div>
                  <strong className="d-block mb-1">Accès au dossier médical</strong>
                  <span className="small">Le dossier médical est confidentiel et protégé. Seuls les professionnels de santé habilités y ont accès.</span>
                </div>
              </div>
            </Alert>
          </Col>
        </Row>

        <style>{`
          .nav-tabs .nav-link { border: none; color: #6c757d; padding: 1rem 1rem; font-weight: 500; transition: all 0.2s; }
          .nav-tabs .nav-link:hover { border: none; color: #0d6efd; background: transparent; }
          .nav-tabs .nav-link.active { color: #0d6efd; border-bottom: 3px solid #0d6efd; background: transparent; }
          .table > :not(caption) > * > * { padding: 0.75rem 0.75rem; vertical-align: middle; }
          .stats-card { position: relative; transition: transform 0.3s ease, box-shadow 0.3s ease; border-radius: 16px; overflow: hidden; }
          .stats-card:hover { transform: translateY(-5px); box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12) !important; }
          .stats-card-gradient { position: absolute; top: 0; left: 0; width: 100%; height: 4px; opacity: 0.8; }
          .stats-icon { width: 48px; height: 48px; border-radius: 12px; display: flex; align-items: center; justify-content: center; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); }
          .display-6 { font-size: 1.75rem; font-weight: 600; }
          @media (max-width: 768px) { 
            .stats-icon { width: 40px; height: 40px; } 
            .stats-icon svg { width: 20px; height: 20px; } 
            .display-6 { font-size: 1.5rem; }
            .table td, .table th { padding: 0.5rem; }
            .detail-row td { padding: 1rem; }
          }
        `}</style>
      </div>
    </div>
  );
};

export default PatientMedicalRecord;